import { Maybe } from '@mxt/zio/codec'
import * as t from 'io-ts'
import { DateFromISOString } from 'io-ts-types'

export const GetCommentListResponse = t.array(
  t.type({
    author: Maybe(t.string),
    message: t.string,
    time: DateFromISOString
  })
)
export type GetCommentListResponse = t.TypeOf<typeof GetCommentListResponse>
